export const languages = {
  fi: 'fi_FI',
  en: 'en_EN',
  se: 'se_SE',
}
